export default "__VITE_ASSET__DHMF3Q94__"